'use strict';

var configModule = angular.module('t2g.config', []);

module.exports = configModule;

configModule.factory('navigationSettings', function(gettextCatalog) {
  var navigationItems = [
    {
      icon: 'icon-ordered-list',
      label: gettextCatalog.getString('First Steps'),
      state: 'private.main.firstSteps',
      highlight: true,
      show: 'office.settings.showFirstSteps',
    },
    {
      icon: 'icon-coachfrog-grey-logo',
      label: gettextCatalog.getString('Sanasearch Profile'),
      attributes: {
        href: 'https://www.sanasearch.ch/de/mein-profil/',
        class: 'visible-xs',
      },
    },
    {
      icon: 'fa fa-calendar',
      label: gettextCatalog.getString('Calendar'),
      state: 'private.main.calendar',
    },
    {
      icon: 'fa fa-users',
      label: '{{labels.customers}}',
      state: 'private.main.customer',
    },
    {
      icon: 'fa fa-handshake-o',
      label: gettextCatalog.getString('Bookings'),
      state: 'private.main.booking',
    },
    {
      icon: 'fa fa-id-card-o',
      label: gettextCatalog.getString('Master data'),
      role: 'manager',
      subMenu: [
        {
          label: gettextCatalog.getString('Services'),
          state: 'private.main.services',
        },
        {
          label: gettextCatalog.getString('Employees'),
          state: 'private.main.resources',
        },
        {
          label: gettextCatalog.getString('Working Hours'),
          state: 'private.main.shiftPlanning',
        },
        {
          label: gettextCatalog.getString('Settings'),
          state: 'private.main.settings',
        },
      ],
    },
    {
      icon: 'fa fa-plus-square',
      label: gettextCatalog.getString('Extras'),
      role: 'manager',
      subMenu: [
        {
          label: gettextCatalog.getString('Custom Fields'),
          state: 'private.main.customFields',
        },
        {
          label: gettextCatalog.getString('Data export'),
          state: 'private.main.export',
        },
      ],
    },
    {
      icon: 'fa fa-calendar-check-o',
      label: gettextCatalog.getString('Calendars Sync'),
      state: 'private.main.syncCalendars',
      role: 'admin',
    },
  ];

  return navigationItems;
});



// WEBPACK FOOTER //
// ./src/config/coachfrog/navigationSettings.js